import React from 'react'

interface ErrorBoundaryState {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  ErrorBoundaryState
> {
  constructor(props: { children: React.ReactNode }) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#09090b] flex items-center justify-center p-6">
          <div className="max-w-md text-center space-y-6">
            <h1 className="text-2xl font-bold text-[#e8e8ec]">
              Etwas ist schiefgelaufen
            </h1>
            <p className="text-[#b0aeb8]">
              Ein unerwarteter Fehler ist aufgetreten. Bitte lade die Seite neu.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="inline-block px-6 py-3 bg-white text-black rounded-lg font-medium hover:bg-white/90 transition-colors"
            >
              Seite neu laden
            </button>
            {this.state.error && (
              <details className="text-left mt-4">
                <summary className="text-sm text-[#707078] cursor-pointer hover:text-[#b0aeb8] transition-colors">
                  Fehlerdetails anzeigen
                </summary>
                <pre className="mt-2 p-3 bg-white/5 border border-white/10 rounded-lg text-xs text-red-400 overflow-auto max-h-40">
                  {this.state.error.message}
                  {this.state.error.stack && `\n\n${this.state.error.stack}`}
                </pre>
              </details>
            )}
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
